const array = (value) => (Array.isArray(value) ? value : []);
const text = (value) => String(value ?? '').trim();

const artifactSkillPresentations = (skills) => {
  const declarations = array(skills)
    .filter(item => item?.target_type === 'skill' && item.registered === true
      && text(item.target_id) && text(item.label))
    .flatMap(item => array(item.artifact_types).map(text).filter(Boolean).map(artifactType => ({
      artifactType, presentation: {
        target_id: text(item.target_id), label: text(item.label),
        ...(Object.hasOwn(item, 'icon_key') ? { icon_key: item.icon_key } : {}),
      },
    })));
  const claims = declarations.reduce((types, { artifactType, presentation }) => {
    const owners = types.get(artifactType) ?? new Map();
    owners.set(presentation.target_id, presentation);
    types.set(artifactType, owners);
    return types;
  }, new Map());
  return new Map([...claims].filter(([, owners]) => owners.size === 1)
    .map(([artifactType, owners]) => [artifactType, owners.values().next().value]));
};

export const EMPTY_SKILL_PROJECTION = Object.freeze({
  revision: 0,
  skills: [],
  capabilities: [],
  composer_options: [],
  available_capability_ids: [],
  artifactSkillPresentations: new Map(),
});

export function normalizeSkillProjection(value = {}) {
  const projection = Object(value);
  return {
    ...projection,
    revision: Number.isInteger(projection.revision) ? projection.revision : 0,
    skills: array(projection.skills),
    artifactSkillPresentations: artifactSkillPresentations(projection.skills),
    capabilities: array(projection.capabilities),
    composer_options: array(projection.composer_options),
    available_capability_ids: array(projection.available_capability_ids)
      .map((item) => String(item || '').trim())
      .filter(Boolean),
  };
}

export const prepareArtifactCollectionPresentation = (collection = {}, presentations = new Map()) => ({
  ...collection,
  items: array(collection.items).map(artifact => ({
    ...artifact,
    skillPresentation: presentations.get(text(artifact.artifact_type)) ?? null,
  })),
});

const SEARCH_PRESENTATION_BY_KIND = new Map([['artifacts', prepareArtifactCollectionPresentation]]);

export const prepareArtifactSearchPresentation = (search, presentations) => {
  if (!search || typeof search.collection !== 'function') return search;
  return {
    ...search,
    collection: (kind, original) => {
      const collection = search.collection(kind, original);
      const prepare = SEARCH_PRESENTATION_BY_KIND.get(kind);
      return prepare ? prepare(collection, presentations) : collection;
    },
  };
};

export function buildSkillActivationRequest(item, revision, requestId) {
  return {
    skillId: String(item?.target_id || '').trim(),
    body: {
      enabled: item?.enabled !== true,
      expected_revision: Number(revision),
      request_id: String(requestId || '').trim(),
    },
  };
}
